var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.35335 11.1243C8.35335 11.4801 8.12 11.9468 7.8225 12.1276L7.00002 12.6584C6.23585 13.1309 5.17418 12.6001 5.17418 11.6551V8.53427C5.17418 8.1201 4.94085 7.58927 4.70168 7.29761L2.46166 4.94094C2.16416 4.64344 1.93085 4.11844 1.93085 3.76261V2.40927C1.93085 1.70344 2.46169 1.17261 3.10919 1.17261H10.8908C11.5383 1.17261 12.0692 1.70343 12.0692 2.35093V3.64593C12.0692 4.11843 11.7717 4.70761 11.48 4.99927",
    stroke: "#3E3A3B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37418 9.63665C10.4051 9.63665 11.2409 8.80093 11.2409 7.76999C11.2409 6.73906 10.4051 5.90332 9.37418 5.90332C8.34325 5.90332 7.50751 6.73906 7.50751 7.76999C7.50751 8.80093 8.34325 9.63665 9.37418 9.63665Z",
    stroke: "#3E3A3B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5908 9.98665L11.0075 9.40332",
    stroke: "#3E3A3B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.98ed361c08b7399fc23133d478d2522c.svg";
export { ForwardRef as ReactComponent };